import { lazy } from 'react';

export const publicRoutes = [
  {
    routeKey: 'login',
    path: '/login',
    name: 'Login',
    component: lazy(() => import('@/pages/Login')),
  },
  {
    routeKey: 'dashboard',
    path: '/dashboard',
    name: 'Dashboard',
    component: lazy(() => import('@/pages/Dashboard')),
  },
  {
    routeKey: 'complaints',
    path: '/complaints',
    name: 'Complaints',
    component: lazy(() => import('@/pages/Complaints')),
  },
  {
    routeKey: 'nearestLocation',
    path: '/nearest-location',
    name: 'NearestLocation',
    component: lazy(() => import('@/pages/NearestLocation')),
  }
];
export const publicRouteNames = publicRoutes.map((route) => route.name);
export const publicRoutePaths = publicRoutes.map((route) => route.path);